import script from "./DuplicateCustomDashboardModule.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicateCustomDashboardModule.vue?vue&type=script&setup=true&lang=js"

import "./DuplicateCustomDashboardModule.vue?vue&type=style&index=0&id=68cb574b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68cb574b"]])

export default __exports__